// form error messages
export const FORM_ERROR_GENERAL = 'Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre Eingaben!'
export const FORM_ERROR_FIELD_REQUIRED = 'Bitte füllen Sie dieses Feld aus!'
export const FORM_ERROR_INCORRECT_FORMAT = 'Bitte geben Sie eine gültige E-Mail Adresse ein!'
